import { render, staticRenderFns } from "./MenuLanguage.vue?vue&type=template&id=1000c4f1&"
import script from "./MenuLanguage.vue?vue&type=script&lang=js&"
export * from "./MenuLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports